export default __webpack_public_path__ + "static/hp-brand-deck-16-a1d79ce7ec467e196210e381e87326c6.png";